import * as React from "react";
import {
    CAROUSEL_BANNERS, GET_NEW_QUOTE_PATH,
    ProductsEnum, Quote,
    resourcesHelper
} from "@falcon/services";
import {pushClickEvent} from "./carouselEvents";
import {Link} from "react-router-dom";

interface IProps {
    newHomeQuotePopUp?: any;
    quotes?: Quote[];
}

export class GetHomeQuoteCarouselBanner extends React.Component<IProps> {

    public render() {
        const isQuotePeriodValid = this.hasValidHomeQuote();
        const voucherIncentiveEnabled: boolean = process.env.REACT_APP_HOME_VOUCHER_INCENTIVE_ENABLED ? JSON.parse(process.env.REACT_APP_HOME_VOUCHER_INCENTIVE_ENABLED) : false;
        return (
            <div className="banner carousel-banner banner-content">
                <img className="banner-icon" src={`/${resourcesHelper.THEME}/img/home-icon.png`}
                     alt="Home icon"/>
                <div className="banner-text">
                    <div className="banner-title mb-3">{resourcesHelper.PRODUCT} Home Insurance Quote</div>
                    <p>
                        Protect your happy place.
                        {voucherIncentiveEnabled && (
                            <>
                                {' '}Get a quote in just 12 questions by 30/11/26 and you could <span className="font-weight-bold">win a £50 Amazon voucher</span>.{' '}
                                <a
                                    href={"https://cloud.comms.allianz.co.uk/homepromotcs2026"}
                                    className="text-decoration-underline muli-bold-16-blue"
                                >
                                    T&Cs
                                </a>
                                {' '}apply.
                            </>
                        )}
                    </p>
                    <p className="mt-3">
                        <img className="carousel-banner-arrow" src={`/${resourcesHelper.THEME}/img/arrow-right.svg`}
                             alt="Arrow icon"/>
                        {!isQuotePeriodValid ? (
                            <button className="btn-text cursor-pointer" onClick={() => this.onClick()}>
                                Get a new home quote
                            </button>
                        ) : (
                            <Link
                                className="text-decoration-underline cursor-pointer text-blue-1 muli-bold-16"
                                onClick={this.onClick}
                                to={{pathname: GET_NEW_QUOTE_PATH}}>
                                Get a new home quote
                            </Link>
                        )}
                    </p>
                </div>
            </div>
        )
    }

    private hasValidHomeQuote(): boolean {
        const quotes: Quote[] = this.props.quotes || [];
        return quotes.some((quote: Quote) =>
            quote.product === ProductsEnum.HOME
        );
    }

    private onClick() {
        const isQuotePeriodValid = this.hasValidHomeQuote();
        if (isQuotePeriodValid) {
            pushClickEvent(
                CAROUSEL_BANNERS.getHomeQuote.name,
                GET_NEW_QUOTE_PATH,
                CAROUSEL_BANNERS.getHomeQuote.id
            );
            return;
        }
        pushClickEvent(
            CAROUSEL_BANNERS.getHomeQuote.name,
            `/journey/show/product/${ProductsEnum.HOME}/process/nb`,
            CAROUSEL_BANNERS.getHomeQuote.id
        );
        if (this.props.newHomeQuotePopUp) {
            this.props.newHomeQuotePopUp();
        }
    }
}
